var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar sidebar--main align-items-center",class:[{ 'in' : _vm.sidebar }]},[_c('navigation',{key:_vm.items.length,attrs:{"items":_vm.doMenuFormat(_vm.items)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }